var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('ACADEMICO.MATRICULA'),"subtitulo":_vm.$t('ACADEMICO.MATRICULA_VISUALIZAR'),"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.irPara}},[_vm._v(_vm._s(_vm.$t('GERAL.VOLTAR')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }